import React from 'react';
import InfoIcon from '@atlaskit/icon/glyph/info';
import Tooltip from '@atlaskit/tooltip';
import { N500A } from '@atlaskit/theme/colors';
import { Field } from '@atlaskit/form';
import Button from '@atlaskit/button';

import { Promotion } from '@css-xp/graphtypes/src/generated-types-new';
import { ENABLE_PARTNER_PROMOTION } from '@atlassian/cssxp-utils-generic';

import { getCustomPromotionReason, getPromotionTitle, renderPromotionValue } from '../../helper';
import { useFeatureToggle } from '../../hooks';

import './partner-promotion-item.scss';

export const PartnerPromotionItem = ({
  partnerPromotion,
  fieldNamePrefix = '',
  isRemovePromotionHidden = false,
  isPromotionReasonHidden = false,
}: {
  partnerPromotion: Promotion;
  fieldNamePrefix?: string;
  isRemovePromotionHidden?: boolean;
  isPromotionReasonHidden?: boolean;
}) => {
  const [isEnabled] = useFeatureToggle();
  const isPartnerPromotionEnabled = isEnabled(ENABLE_PARTNER_PROMOTION);

  if (!isPartnerPromotionEnabled) return null;

  return (
    <Field
      defaultValue={partnerPromotion}
      name={`${fieldNamePrefix}partnerPromotion`}
      id={`${fieldNamePrefix}partnerPromotion`}
    >
      {() => (
        <div data-testid="partner-added-title" className="partner-promotion-list-item" style={{ marginBottom: '1%' }}>
          <strong>{getPromotionTitle(partnerPromotion, { handleEmptyTitle: true })}</strong>
          {partnerPromotion?.applicationReason?.readableName && !isPromotionReasonHidden && (
            <Tooltip content={getCustomPromotionReason(partnerPromotion)} tag={'span'}>
              <InfoIcon size="small" testId="info-icon" label="Info" primaryColor={N500A} />
            </Tooltip>
          )}
          <div className="remove-promotion-link-container">
            <p>{renderPromotionValue(partnerPromotion, { showDuration: true, showReason: true })}</p>
            {!isRemovePromotionHidden && (
              <Button testId="remove-button" appearance="link" isDisabled aria-label="Remove promotion">
                Remove
              </Button>
            )}
          </div>
        </div>
      )}
    </Field>
  );
};
